// extracted by mini-css-extract-plugin
export default {"modal":"VN-z","modalOverlay":"WN-z","outfitHeading":"XN-z"};